import styled, { css } from 'styled-components';
import { convertHexToRGBA } from 'utils/convertHexToRgba';

export const Wrapper = styled.div<{ shouldUseNewUpsellOfferCard?: boolean }>`
  ${({ theme, shouldUseNewUpsellOfferCard }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding: 0 ${theme.spacing.xxxs} 0;

    ${shouldUseNewUpsellOfferCard &&
    css`
      dsb-typography[component='heading'] {
        margin: ${theme.spacing.xs} 0 ${theme.spacing.nano};
      }
    `}

    dsb-button {
      width: 100%;
      margin: ${theme.spacing.sm} 0 ${theme.spacing.xxl};
    }

    dsb-card-base {
      margin: 40px 0;
    }

    div {
      dsb-button {
        margin: 0;
      }
    }
  `}
`;

export const Content = styled.div`
  width: 100%;
  max-width: 514px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  dsb-provider {
    width: 100%;
  }
`;

export const TextParagraphContainer = styled.div`
  display: flex;
`;

export const GroupedButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const UpsellTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
  margin: 16px 0 12px;
  text-align: left;
`;

interface CardThumbProps {
  imageSrc?: string;
}

export const CardThumb = styled.div<CardThumbProps>`
  background-image: url(${(props) => props.imageSrc});
  width: 100%;
  height: 210px;
  background-size: cover;
  background-position: center center;
  border-color: rgba(255, 255, 255, 0.64);
`;

export const Card = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: ${convertHexToRGBA(
      theme?.color?.primary?.light,
      theme?.opacity?.light
    )};
    border: 1px solid #a6a6a6;
    box-sizing: border-box;
    border-radius: 8px;
    margin-top: 42px;
    overflow: hidden;

    dsb-button::part(button) {
      min-width: auto;
    }

    @media (min-width: 534px) {
      margin: 20px auto;
    }
  `}
`;

export const CardInfoContainer = styled.div<{ isMDUpsell: boolean }>`
  padding: 30px;

  img {
    width: 100%;
    max-width: ${({ isMDUpsell }) => (isMDUpsell ? '100%' : '200px')};
    display: flex;
    margin: 0 auto;
  }

  @media (min-width: 426px) {
    padding: 48px 40px;
  }
`;

export const CardDescriptionContainer = styled.div`
  margin: 16px 0 32px;
  text-align: left;
  line-height: 18px;
`;

export const ButtonWrapper = styled.div`
  margin-top: 16px;
`;
